export default __webpack_public_path__ + "static/media/research_main.f4d9fa7b.webp";